export default "__VITE_ASSET__BMBvIHsZ__"